/*
 * Scene 1 — the opening statement.
 *
 * Plays on load rather than on scroll: it's already in view. The lede and
 * heading take the signature masked reveal, and the illustration slides in from
 * the right just behind them — it sits outside its column in the design, which
 * is where the move starts from.
 */
import { defineScene, revealText, slideInFromRight } from '@theme/about-story';

defineScene('about-hero', (root, gsap) => {
	const [lede, heading] = root.querySelectorAll('[data-about-reveal]');
	const figure = root.querySelector('[data-about-figure]');
	const granularity = root.dataset.granularity === 'words' ? 'words' : 'lines';

	const timeline = gsap.timeline({ defaults: { ease: 'power3.out' } });

	if (lede) revealText(lede, { timeline, position: 0, granularity });
	if (heading) revealText(heading, { timeline, position: 0.18, granularity });
	if (figure) slideInFromRight(figure, { timeline, position: 0.25, distance: 220 });
});
